import { Pipe, PipeTransform } from '@angular/core';

/**
 *
 */
@Pipe({name: 'stringPercentageToNb'})
export class StringPercentageToNbPipe implements PipeTransform {
    /**
     *
     * @param value
     * @returns {number}
     */
    transform(value: string): number {
        const valueWithoutPercentage = value.replace('%', '');
        return Number(parseFloat(valueWithoutPercentage).toFixed(4));
    }
}
